import { ResponseType } from "../types/apiTypes";
import {
  EditState,
  IModalConfig,
  MetaDecoratorProps,
} from "../types/ChatInterfaces";

export const BOT_ERROR_MSG = "Please try again.";

export const WIDGET_POPUP_MSG =
  "👋 Hey, I'm Jess, and I'm here to help you with career opportunities.";

export const JOBS_PER_PAGE = 4;

export const ITEMS_PER_PAGE = 4;

export const IFRAME_ANIMATION_CLOSE_DELAY = 200;

export const BOT_ROLE = "System";

export const SMS_MEDIUM = "sms";

export const ALLOWED_RESUME_FILE_TYPES =
  "application/pdf, application/msword, text/plain, application/vnd.openxmlformats-officedocument.wordprocessingml.document";

export const CONSENT_TYPE = {
  ACTIVE: "active",
  PASSIVE: "passive",
  DISABLED: "disabled",
};
export const VALID_MODES = ["published", "draft", "hidden"];

export const ROUTES = {
  v2: "v2",
  sms: "sms",
  web: "web",
  whatsapp: "wa",
};
export const initialModalConfig: IModalConfig = {
  open: false,
  data: null,
  type: "",
};

export const initialOptionSelection = {
  open: false,
  data: null,
  isPopupOpen: false,
};

export const initalChatInputConfigs = {
  disableInput: false,
  placeholder: [],
};

export const initialFooterModalConfig = {
  open: false,
  data: null,
  type: "",
};
export const initialEditState: EditState = {
  isEditing: false,
  originalMessage: null,
  messagesAfterEdit: [],
  originalInputValue: { value: "", question_id: "" },
  previousChatInputConfigs: null,
};
export const footerModalConfigTypes = {
  resetConfirm: "resetConfirm",
  resetCompleted: "resetCompleted",
  historyNotFound: "historyNotFound",
  countryCodePicker: "countryCodePicker",
  translation: "translation",
  leadCapture: "leadCapture",
};

export const MULTI_PLATFORM_MEDIUM_TYPES = {
  initial: "initial",
  thankyou: "thankyou",
};

export const WHATSAPP_MEDIUM_TYPES = {
  initial: "initial",
  thankyou: "thankyou",
};

export const FORM_INPUT_COMPONENTS = [
  ResponseType.FirstName,
  ResponseType.LastName,
  ResponseType.Email,
  ResponseType.OTP,
  ResponseType.TextInput,
  ResponseType.FullName,
  ResponseType.TextArea,
];

export const FORM_PHONE_NUMBER_COMPONENTS = [ResponseType.PhoneNumber];
export const REVIEW_PII_COMPONENTS = [ResponseType.ReviewApplication];

export const FORM_FOOTER_CONFIRM = [
  ResponseType.FormBoolean,
  ResponseType.Select,
  ResponseType.Checkbox,
  ResponseType.ResumeUpload,
  ResponseType.QuestionSet,
  ResponseType.PendingApplies,
  ResponseType.Address,
];

export const COUNTRY_CODE_HEADER = "x-country-code";
export const MAX_USER_MESSAGE_LENGTH = 1000;
export const SHOW_THANKYOU = "showThankyou";
export const DEFAULT_TERMS_LINK = "https://www.joveo.com/privacy-policy/";

export const INNERGROUP_BOTID = "a98da578-1243-4bf4-925b-49520f765326";

export const MINDFIELD_BOT_IDS: string[] = [
  "06ee6ab4-9430-4a28-a051-b5c1b378a03b",
  "73473ad6-92fd-4786-b7c0-f86b47f3a339",
  "ce2bfb22-7b97-4146-b602-679b555e41ac",
  "b4ade1fd-dac7-4db2-bf86-265b925e4eed",
  //v2 bots
  "89e1786e-8c69-4258-9de9-d254c35d6138", //uat
  "097ff2f6-2dd9-4f9f-8c71-6f7cee587e6e", //uat
];
export const ENE_TAO_TOKEN = "25899b50-1b12-4ad4-99ac-e94a59d0cc05";

export const DEFAULT_BG_IMAGE =
  "https://d2dgk297l2uoep.cloudfront.net/conversational-service/bot/5670a752-d181-4ff9-b9bf-11b478476842/config/icon/independentBg.png";
// "https://d2dgk297l2uoep.cloudfront.net/conversational-service/bot/26486bab-4159-442c-8b65-1f3c391073cd/config/icon/indepedentbg.jpg";

export const IMAGE_NOT_FOUND =
  "https://d2dgk297l2uoep.cloudfront.net/conversational-service/bot/26486bab-4159-442c-8b65-1f3c391073cd/config/icon/imageNotFound.png";
export const CONVERSATIONAL_APPLY = "conversational_apply";

export const SR_BOT_TYPE = "smart_recruiters";
export const META_DECORATOR_DATA: Record<string, MetaDecoratorProps> = {
  [SR_BOT_TYPE]: {
    title: "Winston AI",
    description: "",
    imageUrl:
      "https://d2dgk297l2uoep.cloudfront.net/conversational-service/bot/26486bab-4159-442c-8b65-1f3c391073cd/config/icon/winston.png",
    imageAlt: "Winston AI",
    siteName: "Winston AI",
    url: "",
  },
};

export const JOVEO_PREVIEW_DOMAINS = [
  "fe-conversational-bot-preview.prod.joveo.com",
  "jess-preview.prod.joveo.com",
  "fe-conversational-bot.staging.joveo.com",
  "localhost", // to check preview bot locally
];

export const JOVEO_DOMAINS = [
  // "localhost", // to check prod bots locally
  ...JOVEO_PREVIEW_DOMAINS,
  "jess.prod.joveo.com",
  "fe-conversational-bot.prod.joveo.com",
  "jess.prod.joveo.eu",
];
export const INDEPENDENT_BOT_ALLOWED_DOMAINS: Record<string, string[]> = {
  [SR_BOT_TYPE]: [
    ...JOVEO_DOMAINS,
    "winstonchat.smartrecruiters.com",
    "eu.winstonchat.smartrecruiters.com",
  ],
};
export const SKIP_VALUE = "skip";

export const CLOUDFRONT_DOMAINS_EU = [
  "jess.prod.joveo.eu",
  "eu.winstonchat.smartrecruiters.com",
];

export const LEFT_PANE_MAX_WIDTH = "40rem";

export const REVIEW_PII_TIMER_LIMIT_IN_SECONDS = 30;

export const CHAT_MODE = {
  publish: "publish",
  draft: "draft",
  hidden: "hidden",
};
